import { render } from "./Coinflip.vue?vue&type=template&id=af9e5f80&scoped=true"
import script from "./Coinflip.vue?vue&type=script&lang=js"
export * from "./Coinflip.vue?vue&type=script&lang=js"

import "./Coinflip.vue?vue&type=style&index=0&id=af9e5f80&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9e5f80"]])

export default __exports__